module.exports = __webpack_public_path__ + "static/media/matilde-cap-greece-bored.6de50253.png";